module.exports = __webpack_public_path__ + "img/portada10.eaf51f25.svg";